module.exports = __webpack_public_path__ + "static/media/Shabnam-Medium.d7f9cdab.ttf";